import { useState, useContext, useCallback, useMemo } from "react";
import { LanguageContext } from "./LanguageContext";
import it from "../translations/it.json";
import en from "../translations/en.json";
import { Navbar, Container, Nav, Offcanvas } from "react-bootstrap";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "hamburgers/dist/hamburgers.css";
import "../css/navbar.css";

export default function NavigationBar() {
  const { language, setLanguage } = useContext(LanguageContext);

  const translations = useMemo(() => (language === "it" ? it : en), [language]);

  const [show, setShow] = useState(false);

  const handleClose = useCallback(() => setShow(false), []);
  const handleShow = useCallback(() => setShow(true), []);

  const handleScroll = useCallback((targetId) => {
    setShow(false);
    setTimeout(() => {
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const elementPosition = targetElement.offsetTop;
        window.scrollTo({
          top: elementPosition,
          behavior: "smooth",
        });
      }
    }, 300);
  }, []);

  return (
    <Navbar variant="dark" expand="lg" className="mt-3">
      <Container>
        <div className="d-flex align-items-center">
          <img
            src="/assets/it.webp"
            alt="Italiano"
            loading="lazy"
            decoding="async"
            style={{
              width: "30px",
              height: "auto",
              cursor: "pointer",
              marginRight: "10px",
            }}
            onClick={() => setLanguage("it")}
          />
          <img
            src="/assets/en.webp"
            alt="English"
            loading="lazy"
            decoding="async"
            style={{
              width: "30px",
              height: "auto",
              cursor: "pointer",
              marginRight: "10px",
            }}
            onClick={() => setLanguage("en")}
          />
        </div>

        <button
          className={`hamburger hamburger--elastic ${
            show ? "is-active" : ""
          } d-lg-none`}
          type="button"
          onClick={show ? handleClose : handleShow}
          aria-controls="offcanvasNavbar"
          aria-expanded={show}
          aria-label="Toggle navigation"
          style={{
            background: "none",
            border: "none",
            padding: 0,
            margin: 0,
            color: "#fff",
          }}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>

        <Navbar.Offcanvas
          show={show}
          onHide={handleClose}
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="start"
        >
          <Offcanvas.Header closeButton className="btn-close-custom">
            <Offcanvas.Title id="offcanvasNavbarLabel">Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <hr className="linea-mobile" />
            <Nav className="justify-content-center flex-grow-1">
              <Nav.Link onClick={() => handleScroll("chiSono")}>
                {translations.navbar.about}
              </Nav.Link>
              <Nav.Link onClick={() => handleScroll("competenze")}>
                {translations.navbar.progress}
              </Nav.Link>
              <Nav.Link onClick={() => handleScroll("collaborations")}>
                {translations.navbar.collaborations}
              </Nav.Link>
              <Nav.Link onClick={() => handleScroll("projects")}>
                {translations.navbar.projects}
              </Nav.Link>
              <Nav.Link onClick={() => handleScroll("contact")}>
                {translations.navbar.contact}
              </Nav.Link>
            </Nav>
            <hr className="linea-mobile" />
            <div className="ms-auto d-flex align-items-center icone-navbar">
              <a
                href="https://github.com/zargon96"
                target="_blank"
                rel="noopener noreferrer"
                className="github-icon"
                aria-label="Profilo GitHub di Marco Crucitti"
              >
                <FontAwesomeIcon icon={faGithub} size="2x" />
              </a>
              <a
                href="https://www.linkedin.com/in/marcocrucitti96/"
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin-icon"
                aria-label="Profilo LinkedIn di Marco Crucitti"
              >
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>
            </div>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
}
